import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";

export async function index(type) {
  const axios = axiosInstance().primoLab;
  let url = null;

  await axios
    .get(`/sso/${type}`)
    .then(async (response) => {
      url = response.data.url;
    })
    .catch(async (error) => {
      throw error.response.data.errors;
    });

  return { url };
}
